module.exports = __webpack_public_path__ + "media/images/flags/16/Jordan-40ee65738594070be7d8ccbde9b86d78.png";